import {getUserEvent, openUserEventPreviewDialog} from '@Libraries/events.library';
import {EntityCardEntityType} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import type {EntityCardAction} from './entity-card-action.types';

interface EventEntityPayload {
  hashedId: string;
}

/**
 * Clicking an event card opens the event preview modal. The card carries only the
 * event's hashed id; the full EventVO is fetched the same way every other event
 * surface does (getUserEvent → event/getEvent).
 */
export const eventEntityCardAction: EntityCardAction<EventEntityPayload> = {
  entityType: EntityCardEntityType.EVENT,
  parsePayload: (raw): EventEntityPayload => ({hashedId: typeof raw.hashedId === 'string' ? raw.hashedId : ''}),
  onClick: async (payload): Promise<void> => {
    if (payload.hashedId === '') {
      return;
    }
    const event = await getUserEvent(payload.hashedId);
    openUserEventPreviewDialog(event);
  },
};
